import { Client, ChannelListEvent, ChannelListEndEvent } from 'irc-framework';
import { IRC_EVENT } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class ChannelListEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.CHANNEL_LIST, (event: ChannelListEvent) => {
            if (!this.tM.channelListUpdating) {
                this.tM.channelList = [];
                this.tM.channelListUpdating = true;
            }
            this.tM.channelList.push(...event);
            this.tM.renderChannelList();
        });

        this.client.on(IRC_EVENT.CHANNEL_LIST_END, (event: ChannelListEndEvent) => {
            this.tM.renderChannelList();
            this.tM.channelListUpdating = false;
        });
    }
}